import type { ISortClickEvent, ISortClickInput } from '../types/clickEvents';

const sortClick = (input: ISortClickInput): Omit<ISortClickEvent, 'event'> => ({
  linkDetails: input.linkDetails,
});

export default sortClick;
